import React from 'react';
import {ToolTip} from '@trp-innersource/react-communication';

import styles from "./MyToolTip.module.scss"

const MyToolTip = ({ id, descriptionTitle , descriptionBody, popOutPlacement = "top", callerNode, maxNoteWidth = "224px" }) => {
  const description = <div>
    {
      descriptionTitle &&
      <div className={styles["description-title"]}>
        {descriptionTitle}
      </div>
    }
    {
      descriptionBody &&
      <div className={styles["description-body"]}>
        {descriptionBody}
      </div>
    }
  </div>;
  return (
    <>
    <ToolTip
      title={'frequency'}
      aria-label={'frequency tool tip'}
      id={id}
      description={description}
      popOutPlacement={popOutPlacement}
      callerNode={callerNode}
      maxNoteWidth={maxNoteWidth}
    />
    </>
  );
};

export default MyToolTip;
